import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useBestAnchorLocation } from '@apps/accommodations/hooks/useBestAnchorLocation';
import { getValidCoordinates } from '@shared/core/places';
import { addError } from '@shared/utils/logger';
import { VenueDialogAction } from './useEventVenueDialogReducer';
import { EventInfoData } from '@shared/utils/eventInfo';
import { EventVenue } from '@shared/utils/eventPlace';

interface UseBestAnchorLocationEffect {
  venue?: EventVenue;
  eventInfo?: EventInfoData;
  eventHandle?: string;
  dispatch: React.Dispatch<VenueDialogAction>;
}

export const useBestAnchorLocationEffect = ({ venue, eventInfo, eventHandle, dispatch }: UseBestAnchorLocationEffect) => {
  const skip = Boolean(getValidCoordinates(venue) || getValidCoordinates(eventInfo?.locationInfo));

  const onLoadBestAnchorLocation = useEventCallback(location => {
    if (location) {
      dispatch({ type: 'SET_BEST_ANCHOR_LOCATION', location });
    } else {
      addError(new Error('Failed to get location'), { context: 'EventVenueDialog', eventHandle });
    }
  });

  useBestAnchorLocation({ onCompleted: onLoadBestAnchorLocation, skip });
};
